import { ScrollShadow } from './scroll-shadow';

export default ScrollShadow;
